import { useTierGate } from '../hooks/useTierGate'

interface TierGateProps {
  feature: string
  children: React.ReactNode
  fallback?: React.ReactNode
}

export function TierGate({ feature, children, fallback }: TierGateProps) {
  const { hasFeature, tier } = useTierGate()

  if (hasFeature(feature as any)) return <>{children}</>

  return fallback || (
    <div className="border border-white/10 rounded-xl p-8 text-center bg-white/[0.02]">
      <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-white/5 flex items-center justify-center">
        <svg className="w-6 h-6 text-white/40" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
        </svg>
      </div>
      <h3 className="text-lg font-semibold text-white mb-2">Professional Feature</h3>
      <p className="text-white/50 text-sm mb-4">
        Dieses Feature ist ab dem Professional-Plan verfügbar.
      </p>
      <a href="/settings" className="inline-block px-4 py-2 bg-white/10 text-white rounded-lg text-sm hover:bg-white/15 transition-colors">
        Plan upgraden
      </a>
    </div>
  )
}
